import config from '../envConfig/config';

export default {
  resources: {
    logos: 'https://resources.directa24.com/misc/logo/',
    extra: 'https://resources.directa24.com/misc/extra/',
    flags: 'https://resources.directa24.com/country/flag/',
    currencies: 'https://resources.directa24.com/currency/',
    paymentMethods: 'https://resources.directa24.com/cashin/payment_method/',
    payoutMethods: 'https://resources.directa24.com/cashout/payout_method/',
    banks: 'https://resources.directa24.com/cashout/bank/',
    faqs: 'https://resources.directa24.com/misc/merchant_faqs/',
  },
  api: {
    baseUrl: config.REACT_APP_API_BASE_URL,
    // Login
    login: '/auth/session/create',
    logout: '/auth/session/destroy',
    validateToken: '/auth/validate',
    authMfa: '/auth/mfa',
    signUp: '/auth/signUp',
    genericReferral: '/auth/referral/generic',
    olaclickReferral: '/auth/referral/olaclick',
    orderEatReferral: '/auth/referral/ordereat',
    getQRUrl: '/users/mfa',
    signIn: '/users/activation/password',
    activationMfa: '/users/activation/mfa',
    resetMfa: '/users/confirmMfa',
    forgotPass: '/users/forgotPassword',
    resetPass: '/users/resetPassword',
    // Dashboard
    balances: '/balance/:idMerchant',
    balanceCashOut: '/balance/cashout',
    libTimeSummary: '/paymentmethods/summary',
    paymentMethodsSummary: 'paymentmethods/status',
    signUpRequestDetails: '/signUp/merchant',
    notifications: '/notifications/active',
    rates: '/accounts/rates/board',
    // Notes
    notes: '/notes',
    noteDetails: '/notes/:idNote',
    notesExport: '/notes/export',
    addNote: '/notes/addNote',
    notesFlagForReview: '/notes/:idNote/flagForReview',
    // CashIn
    cashIn: '/deposits',
    cashInExport: '/deposits/export',
    cashInExtra: '/deposits/:idTransaction/extra',
    cashInDetails: '/deposits/:idTransaction',
    cashInHistory: '/deposits/:idTransaction/history',
    cashInRejected: '/deposits/rejected/:idTransaction',
    cashInRejectedHistory: '/deposits/rejected/:idTransaction/history',
    cashInLogDetails: '/deposits/logs/:idLog/:direction',
    cashInResend: '/deposits/:idTransaction/resendNotification',
    cashInFlagForReview: '/deposits/:idTransaction/flagForReview',
    cashInReversalForReview: 'deposits/:idTransaction/flagForReviewReversal',
    cashInManualRefund: '/deposits/:idTransaction/refund',
    cashInAccountTypes: '/deposits/:countryIso/accountTypes',
    cashInChangeStatus: '/deposits/:idDeposit/changeStatus/:status',
    cashInRequestManual: '/deposits/requestCashin',
    cashInDocumentTypes: '/deposits/:countryIso/documentTypes',
    cashInPendingVouchers: '/deposits/pendingVoucherQty',
    cashInDownloadReceipt: '/deposits/voucher/:idTransaction',
    cashInSummary: '/deposits/summary',
    cashInDiscardVoucher: 'deposits/voucher/:idDeposit/MERCHANT_DISCARDED',
    installmentsReleases: '/deposits/:idDeposit/installmentsReleases',
    quickPayInformation: '/quickpay/:idTransaction',
    recurringDepositRequest: '/deposits/recurring',
    // Payment Orders
    paymentOrders: '/payment-orders',
    paymentOrder: '/payment-orders/:idOrder',
    paymentOrdersByBatch: '/payment-orders/batch/:idBatch/orders',
    paymentOrdersBatches: '/payment-orders-batch/batches',
    paymentOrderExport: '/payment-orders/export',
    paymentOrdersBatchesChangeStatus: '/payment-orders-batch/:idBatch/status',
    // CashOut
    cashOut: '/cashouts',
    cashOutExport: '/cashouts/export',
    cashOutDetails: '/cashouts/:idTransaction',
    cashOutHistory: '/cashouts/:idTransaction/history',
    cashOutRejected: '/cashouts/rejected/:idTransaction',
    cashOutRejectedHistory: '/cashouts/rejected/:idTransaction/history',
    cashOutLogDetails: '/cashouts/logs/:idLog/:direction',
    cashOutResend: '/cashouts/:idTransaction/resendNotification',
    cashOutFlagForReview: '/cashouts/:idTransaction/flagForReview',
    cashOutRequestReceipt: '/cashouts/requestReceipt',
    cashOutRequestManual: '/cashouts/requestCashout',
    cashOutBeneficiaries: '/cashouts/beneficiaries',
    cashOutNotificationUrl: '/cashouts/notificationUrl',
    cashOutDocumentTypes: '/cashouts/:countryIso/documentTypes',
    cashOutBankCodes: '/cashouts/:countryIso/bankCode',
    cashOutChangeStatus: '/cashouts/:idTransaction/changeStatus',
    cashOutOnHoldStatus: '/cashouts/:idTransaction/onHoldStatus',
    cashOutDownloadReceipt: '/cashouts/voucher/:idTransaction',
    cashOutsBatch: '/cashouts/cashoutBatch',
    cashOutsBatchDownload: '/cashouts/cashoutBatch/:idBatch',
    cashOutsFullBatchDownload: '/cashouts/cashoutFullBatch/:idBatch',
    cashOutRequestBatch: '/cashouts/requestCashoutBatch',
    cashOutRequestFullBatch: '/cashouts/requestFullCashoutBatch/:countryIso',
    cashOutRequestBatchConfirm: '/cashouts/cashoutBatchConfirm/:idBatch',
    cashOutRequestFullBatchConfirm: '/cashouts/cashoutFullBatchConfirm/:idBatch',
    cashOutResendSmsNotification: '/cashouts/notify/:idTransaction',
    cashOutCancel: '/cashouts/cancel/:idTransaction',
    cashOutsBatchDownloadFile: '/cashouts/files/downloadFileExample/?name=:name&path=:path',
    // Beneficiaries
    beneficiaries: '/cashouts/beneficiaries',
    beneficiaryDetails: '/cashouts/beneficiaries/:idBeneficiary',
    // RecurringPayments
    recurringPayments: '/deposits/recurring',
    recurringPaymentsExport: '/deposits/recurring/export',
    transactionsCountries: '/:transactionType/countries',
    transactionsExport: '/:transactionType/export',
    // Upcoming payments
    upcomingPayments: '/deposits/upcomingPayments',
    upcomingPaymentTotals: '/deposits/totalUpcomingPayments',
    // Refunds
    refund: '/refund',
    refundDetails: '/refund/:idRefund',
    refundHistory: '/refund/:idTransaction/log',
    refundRejectedHistory: '/refund/rejected/:idTransaction/log',
    refundDetailsRejected: '/refund/rejected/:idRefund',
    refundLogDetails: '/refund/logs/:idLog/:direction',
    refundResend: '/refund/:idTransaction/resendNotification',
    refundBankCodes: 'refund/:countryIso/bankCodes',
    refundDocumentTypes: '/refund/:countryIso/documentTypes',
    refundChangeStatus: '/refund/:idTransaction/:status',
    refundAccountTypes: '/refund/accountTypes',
    refundRefoundVoucher: '/refund/:idRefund/voucher',
    // Chargebacks
    chargeback: '/chargeback',
    chargebacksExport: '/chargeback/export',
    // Balance report
    balanceReport: '/balance/report',
    balanceReportExport: '/balance/export',
    // Balance Wallet report
    balanceWalletReport: '/balance/report/wallet',
    balanceWalletReportExport: 'balance/report/wallet/export',
    // Balance Wallet Tranfer
    walletTranfer: '/wallet/transaction',
    // Settlements
    settlements: '/settlements',
    settlementsHistory: '/settlements',
    settlementsExport: '/settlements/export',
    settlementDetails: '/settlements/:idSettlement',
    cancelSettlement: '/settlements/:idSettlement/cancel',
    confirmSettlement: '/settlements/:idSettlement/confirm',
    settlementsAvailableBalance: '/settlements/available',
    settlementsBanks: '/merchants/bankAccounts/savings',
    settlementsFee: '/settlements/fees',
    settlementsCreate: '/settlements/create',
    settlementsCollectionAgents: '/settlements/collectionAgents',
    settlementAstropayBanks: '/settlements/:collectionAgent/astropayBanks',
    settlementCurrencies: '/settlements/currencies',
    scheduledSettlements: 'settlements/:idMerchant/scheduled',
    settlementsReportFiles: '/settlements/:idSettlement/report',
    // Payments Methods
    paymentMethodsAll: '/paymentmethods/all',
    paymentMethods: '/paymentmethods',
    paymentMethodDetails: '/paymentmethods/description',
    availablePaymentMethod: '/paymentmethods/available',
    paymentMethodCountries: '/paymentmethods/countries',
    paymentMethodStatus: '/paymentmethods/updateStatus',
    // Clients
    clients: '/clients',
    clientDetails: '/clients/:idClient/details',
    clientPaymentMethods: '/clients/:idClient/paymentMethods',
    clientExport: '/clients/export',
    clientHistory: '/clients/:idClient/history',
    clientStatusChange: '/clients/:idClient/statusChange',
    clientLimitIncrease: '/clients/:idClient/limitIncrease',
    // Tickets
    tickets: '/tickets',
    ticketsSummary: '/tickets/summary',
    ticketDetails: '/tickets/:idTicket',
    createTicket: '/tickets/createTicket',
    addTicketAttachment: '/tickets/:idTicket/addAttachment',
    removeTicketAttachment: '/tickets/:idAttachment/removeAttachment',
    cancelTicket: '/tickets/:idTicket/cancelTicket',
    confirmTicket: '/tickets/:idTicket/confirmTicket',
    closeTicket: '/tickets/:idTicket/closeTicket',
    closeMultipleTickets: '/tickets/closeMultipleTickets',
    ticketsTypes: '/tickets/types',
    getTicketAttachment: '/tickets/:idAttachment/getAttachment',
    // Accounts
    accounts: '/users',
    createAccount: '/users/create',
    detailsAccountMerchant: '/users/:idUser/:idMerchant',
    detailsAccountAstro: '/users/:idUser/astropay',
    editAccountMerchant: '/users/:idUser/:idMerchant/editUser',
    editAccountAstro: '/users/:idUser/editAstroUser',
    resetAccountPass: 'users/:idUser/resetPassword',
    resetAccountMFA: 'users/:idUser/resetMFA',
    resendAccountActivation: 'users/:idUser/resendActivation',
    enableMerchantAccount: '/users/:idUser/:idMerchant/enableUser',
    disableMerchantAccount: '/users/:idUser/:idMerchant/disableUser',
    enableAstroAccount: '/users/:idUser/enableUserAstro',
    disableAstroAccount: '/users/:idUser/disableUserAstro',
    removeAstroAccount: '/users/:idUser/removeUserAstro',
    removeMerchantAccount: '/users/:idUser/:idMerchant/removeUser',
    addMultiMerchant: '/users/:idUser/:idMerchant/addUserMerchant',
    merchantMailGroupList: 'users/:idMerchant/mailGroups',
    restoreMerchantAccount: '/users/:idUser/:idMerchant/reactivateUser',
    // Profile details
    accountDetails: '/users/me',
    accountEdit: '/users/:idUser/edit',
    changePassword: '/users/:idUser/changePassword',
    accountAddPhoto: '/users/:idUser/addPhoto',
    accountRemovePhoto: '/users/:idUser/removePhoto',
    roles: '/users/roles',
    capabilities: '/users/capabilities?merchantId=:idMerchant',
    changeMfa: '/users/:idUser/changeMfa',
    presets: '/merchants/allPresets',
    savePreset: '/merchants/savePreset',
    removePreset: '/merchants/:idPreset/removePreset',
    switchContext: '/auth/:idMerchant/switchContext',
    // Merchants
    merchants: '/merchants/all',
    subMerchantsList: '/merchants/subMerchantsList',
    mainMerchantsList: '/merchants/mainMerchantsList',
    merchantsList: '/merchants',
    referredMerchantsList: '/merchants/referredMerchants',
    referredMerchantEditFee: '/merchants/subMerchantFee',
    createReferralMerchantStg: '/signUp/createMerchantUserStg/USD/USD',
    merchantDetails: '/merchants/me',
    merchantsCountries: '/merchants/countries',
    merchantsCountriesCurrency: '/merchants/countriesCurrency',
    merchantsReferralsFiles: '/merchants/:idMerchant/downloadReferralsFiles',
    // Merchant config
    merchant: '/merchants/:merchantId',
    merchantConfigCompany: '/merchants/:idMerchant/company',
    countryChangeRegistry: '/merchants/:idMerchant/countryChangeRegistry',
    merchantAddLogo: '/merchants/:idMerchant/addLogo',
    merchantAddPaymentPageLogo: '/merchants/:idMerchant/addPaymentLogo',
    merchantRemovePaymentPageLogo: '/merchants/:idMerchant/removePaymentLogo',
    merchantRemoveLogo: '/merchants/:idMerchant/removeLogo',
    merchantConfigFinancial: '/merchants/:idMerchant/bankDetails',
    merchantConfigBankTicket: '/merchants/:idMerchant/bankDetailsTicket',
    merchantConfigContacts: '/merchants/:idMerchant/supportAddress',
    merchantConfigIntegration: '/merchants/:idMerchant/integrationDetails',
    merchantConfigIntegrationSecretKey: '/merchants/:idMerchant/secretKey',
    merchantConfigFee: '/merchants/:idMerchant/config',
    merchantConfigFeeByPaymentType: '/merchants/:idMerchant/fees/payment_type',
    merchantConfigTier: '/merchants/:idMerchant/configTier',
    merchantConfigFx: '/merchants/:idMerchant/fxConfig',
    merchantConfigFxEdit: '/merchants/:idMerchant/editFxConfig',
    merchantConfigGeneral: '/merchants/:idMerchant/generalConfig',
    merchantConfigGeneralEdit: '/merchants/:idMerchant/editGeneralConfig',
    merchantConfigEditCurrency: '/merchants/:idMerchant/editBalanceConfig/:currency',
    merchantConfigGeneralLegal: '/merchants/:idMerchant/editGeneralLegalConfig',
    merchantConfigGeneralCommercial: '/merchants/:idMerchant/editGeneralCommercialConfig',
    merchantConfigMaintenanceFee: '/merchants/:idMerchant/maintenanceFee/:maintenanceFee',
    merchantProcessingEntities: '/merchants/processingEntity',
    merchantPossibleCurrencies: '/merchants/:idMerchant/currencies',
    merchantCashinLimits: 'merchants/:idMerchant/cashinLimits',
    merchantCashoutLimits: 'merchants/:idMerchant/cashoutLimits',
    merchantCashinCountries: 'merchants/:idMerchant/cashinCountries',
    merchantCashoutFee: 'merchants/:idMerchant/cashoutFee',
    merchantCashoutStatus: 'merchants/:idMerchant/cashoutStatus',
    merchantMaintenanceFee: 'merchants/:idMerchant/maintenanceFee',
    merchantActivateCashout: 'merchants/:idMerchant/activateCashout/:status',
    merchantMailGroups: '/merchants/:idMerchant/mailGroups',
    merchantRemoveMailGroup: '/merchants/:idMerchant/:idGroup/mailGroups',
    merchantIps: '/merchants/:idMerchant/ips',
    merchantAddDepositIp: 'merchants/:idMerchant/integrationDetails/addDepositIp',
    merchantRemoveDepositIp: 'merchants/:idMerchant/integrationDetails/removeDepositIp',
    merchantAddCashoutIp: 'merchants/:idMerchant/integrationDetails/addCashoutIp',
    merchantRemoveCashoutIp: 'merchants/:idMerchant/integrationDetails/removeCashoutIp',
    merchantGenerateDepositTransKey: 'merchants/generateDepositTransKey',
    merchantGenerateCashoutTransKey: 'merchants/generateCashoutTransKey',
    merchantGenerateWebStatusTransKey: 'merchants/generateWebStatusTransKey',
    merchantChargebackFeeData: 'merchants/:idMerchant/chargebackFee',
    referralConfig: 'merchants/:idMerchant/referralConfig',
    merchantConfigFeeAmountRange: '/merchants/:idMerchant/configFeeAmountRange',
    merchantConfigFeeAmountRangeEdit: 'merchants/:idMerchant/configFeeAmountRange/:idMerchantsFeeAmountRange',
    merchantFeeAmountRange: 'merchants/:idMerchant/configFeeAmountRange',
    merchantGenerateDepositApiKey: 'merchants/generateDepositApiKey',
    merchantGenerateCashoutApiKey: 'merchants/generateCashoutApiKey',
    merchantGenerateWebStatusApiKey: 'merchants/generateWebStatusApiKey',
    merchantGenerateDepositSecretKey: 'merchants/generateDepositSecretKey',
    merchantGenerateCashoutSecretKey: 'merchants/generateCashoutSecretKey',
    merchantLocalBank: '/merchants/:idMerchant/localBank',
    // Rolling Reserve
    rollingReserveConfig: 'merchants/:idMerchant/rollingReserve/config',
    rollingReserveCreateConfig: 'merchants/:idMerchant/rollingReserve/config',
    rollingReserveDetails: '/rollingReserve/total/details/:idMerchant',
    rollingReserveDaily: '/rollingReserve/daily/:idMerchant',
    rollingReserveNextRelease: '/rollingReserve/toRelease/:idMerchant',
    // Sign Up Requests
    signUpRequests: '/signUp',
    signUpRequestStatus: '/signUp/:idRequest/changeStatus',
    signUpGoLive: '/signUp/goLive',
    signUpRequestSetCommercial: '/signUp/:idRequest/changeCommercial/:commercial',
    SingUpReferralDownloadFile: '/auth/files/downloadFileTermAndConditions?name=:name&path=:path',
    signUpAttachments: '/signUp/:idRequest/attachments',
    // Notifications
    saveNotification: '/notifications/add',
    editNotification: '/notifications/:idNotification/edit',
    removeNotification: '/notifications/remove',
    getNotifications: '/notifications',
    // Balance transfers
    balanceTransfers: '/accounts/movements',
    balanceTransfersExport: '/accounts/movements/export',
    balanceAccounts: '/accounts/:idMerchant',
    balanceAccountRates: '/accounts/rates',
    balanceCurrencies: '/accounts/currencies',
    balanceAllCurrencies: '/accounts/currencies/all',
    balanceCategories: '/accounts/categories',
    balanceCreateAccount: '/accounts',
    balanceCreateTransfer: '/accounts/preview',
    balanceCreateTransferConfirm: '/accounts/confirm',
    // Top ups
    topUps: '/topUps',
    topUpsDetails: '/topUps/:idTopUp',
    topUpsCancel: '/topUps/:idTopUp/cancel',
    topUpsFinalize: '/topUps/:idTopUp/finalize',
    topUpsCredits: '/topUps/:idTopUp/credits',
    topUpsCreditTypes: '/topUps/credits/types',
    topUpsAssignBank: '/topUps/:idTopUp/bank',
    topUpsPartialComplete: '/topUps/:idTopUp/credits/partial',
    topUpsTotalComplete: '/topUps/:idTopUp/credits/total',
    // Finance
    foreignAccounts: '/finance/foreignAccounts',
    topUpsCurrencies: '/finance/currencies/topUp',
    topUpsTransferTypes: '/finance/foreignAccounts/transferTypes',

    // Internal transfers
    internalTransfer: '/internaltransfer',
    internalTransferConfirm: '/internaltransfer/confirm',
    commercialRelationship: '/commercialrelationship',
    currencyExchange: '/exchange/:currency',
    commercialRelationshipConfirm: '/commercialrelationship/confirm',

    // KYCTool
    kyc: '/kyctool',
    authusContactUs: '/authus/contact',
    authusRequestSearches: '/authus/requestSearches',
    getKYCData: '/authus/kyc',
    authusGetRemainingCalls: '/authus/remainingCalls',
    setFirstSeeKYC: 'merchants/kyc',

    // Sub-Merchants PSP
    pspMerchants: '/psp/merchants',
    subMerchants: '/psp/submerchants',
    subMerchantTransactions: '/psp/submerchants/:subMerchantId/balance-report',
    subMerchantTransactionsExport: '/psp/submerchants/:subMerchantId/balance-report/export',
  },
};
